import { data, useRoutes, type LoaderFunctionArgs } from "react-router";
import { appRoutes } from "../router/appRoutes";
import { LoadingSpinner } from "../router/LoadingSpinner";
import { isKnownAppPath } from "./knownAppPath";

/**
 * Everything that isn't server-rendered: the existing route tree
 * (src/router/appRoutes.tsx) rendered as descendant routes in the browser.
 *
 * The server only sends the root document with the HydrateFallback spinner
 * for these URLs, exactly like the old SPA shell, plus correct <head> tags
 * from the root meta. Login state, viewport and other browser-only state
 * never have to match server HTML here.
 */

/** Real 404 status for URLs that match no route. */
export function loader({ request }: LoaderFunctionArgs) {
  const { pathname } = new URL(request.url);
  return isKnownAppPath(pathname) ? null : data(null, { status: 404 });
}

// Client navigations never need the server loader above.
export async function clientLoader() {
  return null;
}
clientLoader.hydrate = true as const;

export function HydrateFallback() {
  return <LoadingSpinner />;
}

export default function ClientOnlyApp() {
  return useRoutes(appRoutes);
}
